// extracted by mini-css-extract-plugin
export default {"background":"dark_background__W5soN","glas":"dark_glas__Hl4Qt"};